import { useEffect, useState } from "react";
import Accordion from "../campusLife/accordion";
import { PropTypes } from 'prop-types';

const HowToDonate = ({ accordionTexts }) => {
   
    const [accordion, setAccordion] = useState([]);

    useEffect(()=>{
        setAccordion(
            accordionTexts?.map((accordion, index) => {
                return {
                    open: index === 0 ? true : false,
                    question: accordion.title,
                    answer: accordion.contents
    
                }
            })
        )
    },[accordionTexts])

    return (
        <div className="flex flex-col gap-2 p-6 md:p-0">
            <h2 className="w-auto  text-slate-900 text-lg font-bold">How to Donate</h2>
            <Accordion accordion={accordion} setAccordion={setAccordion} />

        </div>
    )
}
HowToDonate.propTypes = {
    accordionTexts: PropTypes.any
}
export default HowToDonate